/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import request from '@/utils/http';

// 查询
export const getLists = (data) => {
    return request({
        url: `/api-tms/dispatch/searchloadsonglist`,
        method: 'post',
        data
    });
};

// 重新推送
export const getAgainLists = (data) => {
    return request({
        url: `/api-tms/dispatch/pushtoloadsong`,
        method: 'post',
        data
    });
};

// 编辑保存
export const getUpdateLists = (data) => {
    return request({
        url: `/api-tms/dispatch/updateloadsong`,
        method: 'put',
        data
    });
};

// G7页面删除
export const deleteList = (data) => {
    return request({
        url: `/api-tms/dispatch/deleteloadsong/${data}`,
        method: 'delete'
    });
};
// 导出
export const noCarPushLogExport = (data) => {
    return request({
        url: `/api-tms/export/noCarPushLog`,
        method: 'post',
        data
    });
};
export const arrivePush = (data) => {
    return request({
        url: `/api-tms/dispatch/loadsongarri`,
        method: 'post',
        data
    });
};
// 传化更新时间
export const updateTime = (data) => {
    return request({
        url: `/api-tms//dispatch/chuanHuaModifyTime`,
        method: 'post',
        data
    });
};
